/*
 * Project: LegalPlace assistant
 * File: src\redux\actions\output.js
 * Author: Nasreddine DAIFALLAH
 * Version: 1.0
 */
import { lpIdGetPure, lpIdGetCopy } from '../../logic/global_getter';
import { filterRadios } from '../../logic/utils/tree_operations';
import lpApp from '../../app/lp_app';

const INIT_OUTPUT_VARIABLE = 'INIT_OUTPUT_VARIABLE_';
const INIT_OUTPUT_OPTION = 'INIT_OUTPUT_OPTION_';
const EDIT_VARIABLE_VALUE = 'EDIT_VARIABLE_VALUE_';
const EDIT_OPTION_VALUE = 'EDIT_OPTION_VALUE_';
const EDIT_OPTION_RADIO = 'EDIT_OPTION_RADIO_';
// rem_first
const REMOVE_FIRST_OPTION = 'REMOVE_FIRST';
const REMOVE_FIRST_VARIABLE = 'REMOVE_FIRST_VARIABLE';


// build actions
function initOutputVariable(id, key, value = '') {
  return {
    type: INIT_OUTPUT_VARIABLE,
    id,
    key,
    value,
  };
}

function initOutputOption(id, key, val = '') {
  return {
    type: INIT_OUTPUT_OPTION,
    id,
    key,
    value: val,
  };
}

function editVariable(id, value) {
  return {
    type: EDIT_VARIABLE_VALUE,
    id,
    value,
  };
}

function editOption(id, value) {
  return {
    type: EDIT_OPTION_VALUE,
    id,
    value,
  };
}

function checkRadio(key, value) {
  return {
    type: EDIT_OPTION_RADIO,
    key,
    value,
  };
}

function checkRadio1(id, parent) {
  return (dispatch) => {
    const copy = lpIdGetCopy(id);
    const parentCId = lpIdGetPure(parent);
    // get siblings
    // debugger;
    let { children } = lpApp.references.getOption(parentCId);
    children = filterRadios(children);
    if (copy !== -2) {
      children = children.map(idx => `${idx}_${copy}`);
    }
    // put them to all to false, except for the
    children.forEach((idx) => {
      if (idx == id) {
        dispatch(editOption(idx, true));
      } else {
        dispatch(editOption(idx, false));
      }
    });
  };
}

const REM_OPTION_DUP = 'REM_OPTION_DUP';
const REM_VARIABLE_DUP = 'REM_VARIABLE_DUP';

function removeDuplicateFromOption(id) {
  return {
    type: REM_OPTION_DUP,
    id,
  };
}

function removeDuplicateFromVariables(id) {
  return {
    type: REM_VARIABLE_DUP,
    id,
  };
}
// removing the first option
function removeFirstOption(firstCopy, id) {
  return {
    type: REMOVE_FIRST_OPTION,
    firstCopy,
    id,
  };
}

function removeFirstVariable(firstCopy, id) {
  return {
    type: REMOVE_FIRST_VARIABLE,
    firstCopy,
    id,
  };
}

export {
  INIT_OUTPUT_OPTION,
  REM_OPTION_DUP,
  REM_VARIABLE_DUP,
  INIT_OUTPUT_VARIABLE,
  EDIT_OPTION_VALUE,
  EDIT_VARIABLE_VALUE,
  EDIT_OPTION_RADIO,
  REMOVE_FIRST_OPTION,
  REMOVE_FIRST_VARIABLE,
  initOutputOption,
  initOutputVariable,
  editOption,
  editVariable,
  checkRadio,
  checkRadio1,
  removeDuplicateFromOption,
  removeDuplicateFromVariables,
  removeFirstOption,
  removeFirstVariable,
};



// WEBPACK FOOTER //
// ./src/redux/actions/output.js